module.exports = __webpack_public_path__ + "static/media/showcase_morning_mobile.53a87bd2.png";